import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=57c7084a&scoped=true"
import script from "./ItemTable.vue?vue&type=script&lang=js"
export * from "./ItemTable.vue?vue&type=script&lang=js"
import style0 from "./ItemTable.vue?vue&type=style&index=0&id=57c7084a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7084a",
  null
  
)

export default component.exports